import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import Sidebar from '@rio-cloud/rio-uikit/Sidebar';
import React, { useEffect } from 'react';
import { CustomFormattedMessage } from '../../../../i18n/i18n';
import { ActiveServicesTable } from './activeServiceTable/ActiveServicesTable';
import { useAppDispatch } from '../../../../state/hooks';
import {
  DialogMode,
  openAddNewServiceCardDialog,
  openConfigurationDialog,
  unselectVehicle,
} from '../../state/onboardingUiSlice';
import { VehicleHeadline } from '../VehicleHeadline';
import { useLocation } from 'react-router-dom';
import Button from '@rio-cloud/rio-uikit/Button';
import isEmpty from 'lodash/isEmpty';
import { ONBOARDING_ROUTE } from '../../../../routes/routes';
import { useSelectedVehicle } from '../../../../state/vehicles/useVehicles';
import { appConfiguration } from '../../../../configuration/appConfiguration';
import { PaymentPartnerType } from '../../../../codegen/vehicles';

export const SIDEBAR_LABEL_COLOR = 'text-color-gray';
export const SIDEBAR_DATA_COLOR = 'text-color-dark';

export const VehicleSidebar: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const defaultPaymentPartnerType = appConfiguration
    .supportedPaymentPartnerTypes[0] as PaymentPartnerType;

  useEffect(() => {
    if (location.pathname !== ONBOARDING_ROUTE) {
      dispatch(unselectVehicle());
    }
  }, [location.pathname]);

  const selectedVehicle = useSelectedVehicle();

  const handleClose = () => {
    dispatch(unselectVehicle());
  };

  const hasPaymentMethods = !isEmpty(selectedVehicle?.paymentMethods);

  const onEditServices = () => {
    dispatch(openConfigurationDialog(DialogMode.SERVICES));
  };

  const onAddCard = () => {
    dispatch(
      openAddNewServiceCardDialog({
        paymentPartnerType: defaultPaymentPartnerType,
      }),
    );
  };

  if (!selectedVehicle) {
    return <></>;
  }

  return (
    <ApplicationLayout.Sidebar className={'right'}>
      <Sidebar
        data-testid={'onboarding-vehicle-sidebar'}
        title={
          <>
            <CustomFormattedMessage id={'onboarding.sidebar.title'} />
          </>
        }
        titleClassName={
          'padding-left-10 text-light text-uppercase text-size-16'
        }
        onClose={handleClose}
        resizable
        position={'right'}
        width={400}
        minWidth={330}
        maxWidth={600}
        fly
      >
        <div className={'padding-left-20 padding-right-20'}>
          <div className={'display-flex flex-column align-items-start gap-10'}>
            <VehicleHeadline vehicle={selectedVehicle} />
            <div className={'display-flex gap-5'}>
              <Button
                bsStyle={'primary'}
                type={'button'}
                onClick={onAddCard}
                data-testid={'onboarding-vehicle-sidebar-add-card-button'}
              >
                <span className={'rioglyph rioglyph-plus'} />
                <CustomFormattedMessage id="onboarding.sidebar.body.addCard" />
              </Button>
              {hasPaymentMethods && (
                <Button
                  type={'button'}
                  onClick={onEditServices}
                  data-testid={'onboarding-vehicle-sidebar-edit-button'}
                >
                  <span className={'rioglyph rioglyph-pencil'} />
                  <CustomFormattedMessage id="onboarding.sidebar.body.editServices" />
                </Button>
              )}
            </div>
          </div>
          <ActiveServicesTable />
        </div>
      </Sidebar>
    </ApplicationLayout.Sidebar>
  );
};
